export const sidebarWidth = 450
export const largeMainScreenWidth = 1361
export const mediumMainScreenWidth = 914
export const smallMainScreenWidth = 945
